import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/conversations/delivery-unknowns'),
      name: 'teletel_delivery_unknowns',
      meta: { permissions: ['administrator'] },
      component: () =>
        import(
          'dashboard/components-next/teletel/deliveryUnknown/DeliveryUnknownList.vue'
        ),
    },
  ],
};
